import generalMailsIcons from "@/components/generalMailsIcons";
import { cn } from "@/lib/utils";
import React from "react";
import { NavLink } from "react-router-dom";

interface GeneralItemProps {
    label: string | React.ReactNode;
    count?: number;
    to: string;
    id: string;
}

const GeneralItem = ({ label, count, to, id }: GeneralItemProps) => {
    const icon = generalMailsIcons.find((i) => i.id === id);

    return (
        <NavLink
            className={({ isActive }) =>
                cn(
                    "flex w-full items-center justify-between gap-2 rounded-md px-1.5 py-2 text-xs hover:bg-surface-activeFg hover:text-accent-foreground",
                    isActive && "bg-surface-infoBg",
                )
            }
            to={to}
        >
            <p className="flex items-center gap-2 text-left">
                {icon && <img alt="" className="h-4 w-4" src={icon.icon} />}
                <span className="flex items-center gap-1">{label}</span>
            </p>
            <span className="text-[9px] text-text-mainTitle">{count || 0}</span>
        </NavLink>
    );
};

export default GeneralItem;
